import React from 'react'
import PropTypes from 'prop-types'
import { System } from '@olxbr/olx-icons'
import { StepButton } from '../../molecules'
import { CONFIRM_PHONE_PATH, CONFIRM_EMAIL_PATH, WALLET_URL } from '../../../settings'
import Lurker from '../../../util/lurker'

const lurker = new Lurker('level_page')

export class LevelSteps extends React.Component {
  onClickEmailVerificationTask = () => {
    lurker.clickEvt('email_verification')
  }

  renderEmailVerificationTask = () => {
    const { email, emailVerified } = this.props
    return (
      <div className="flex flex-col items-stretch mb-2">
        <StepButton
          icon={System.Mail}
          title="Verifique seu e-mail"
          titleDone="E-mail verificado"
          description="Receba as comunicações da conta e alertas de segurança."
          done={emailVerified}
          path={`${CONFIRM_EMAIL_PATH}?email=${email}`}
          onClick={this.onClickEmailVerificationTask}
        />
      </div>
    )
  }

  onClickPhoneVerificationTask = () => {
    lurker.clickEvt('phone_verification')
  }

  renderPhoneVerificationTask = () => {
    const { phoneVerified } = this.props
    return (
      <div className="flex flex-col items-stretch mb-2">
        <StepButton
          icon={System.Phone}
          title="Verifique seu telefone"
          titleDone="Telefone verificado"
          description="Conta segura para anunciar e interagir com outros usuários."
          done={phoneVerified}
          path={CONFIRM_PHONE_PATH}
          onClick={this.onClickPhoneVerificationTask}
        />
      </div>
    )
  }

  onClickOlxPayTask = () => {
    lurker.clickEvt('olx_pay')
  }

  renderOlxPayTask = () => {
    const { hasWallet } = this.props
    return (
      <div className="flex flex-col items-stretch mb-2">
        <StepButton
          icon={System.Wallet}
          title="Ative a Carteira OLX"
          titleDone="Carteira OLX ativada"
          description="Compre e venda com mais segurança e praticidade."
          done={hasWallet}
          path={WALLET_URL}
          onClick={this.onClickOlxPayTask}
        />
      </div>
    )
  }

  renderProfileCreationTask = () => {
    const { profileCreated } = this.props
    return (
      <div className="flex flex-col items-stretch">
        <StepButton
          icon={System.User}
          title="Criar meu perfil"
          titleDone="Meu perfil criado"
          description="Informações para outros usuários negociarem com maior segurança."
          done={profileCreated}
          path="#"
        />
      </div>
    )
  }

  render() {
    return (
      <div className="flex flex-col items-stretch">
        <span className="typo-body-large font-semibold mb-3">Etapas para aumentar seu nível</span>
        {this.renderEmailVerificationTask()}
        {this.renderPhoneVerificationTask()}
        {this.renderOlxPayTask()}
        {this.renderProfileCreationTask()}
      </div>
    )
  }
}

LevelSteps.propTypes = {
  profileCreated: PropTypes.bool,
  hasWallet: PropTypes.bool,
  phoneVerified: PropTypes.bool,
  emailVerified: PropTypes.bool,
  email: PropTypes.string,
}

LevelSteps.defaultProps = {
  profileCreated: true,
}
